<ng-container *ngIf="isThemeAvailable">
  <p *ngIf="environment !== 'Develop' && environment !== 'PRODUKTION'">
    ENVIRONMENT: {{ environment }} - {{settings.config.environmentMode}}</p>
  <lv-entwicklerleiste *ngIf="environment !== 'PRODUKTION' && shellConfigService.getParameter().showEntwicklerleiste"></lv-entwicklerleiste>
  <lv-antrag #antrag></lv-antrag>
</ng-container>
